<app-modal [(isOpen)]="isOpen" size="sm" (closeModal)="onClose()">
  <ng-container header>{{ config().title }}</ng-container>

  <div body>
    <p class="text-base leading-relaxed text-gray-500 dark:text-gray-400">
      {{ config().message }}
    </p>
  </div>

  <div footer class="flex justify-end gap-2">
    @if (config().type === 'confirm') {
      <app-button size="small" variant="secondary" (click)="handleCancel()">
        {{ config().cancelText }}
      </app-button>
    }
    <app-button size="small" (click)="handleConfirm()">
      {{ config().confirmText }}
    </app-button>
  </div>
</app-modal>
